import { registerComponent } from '@gig/magic-common';
import InputComponent from './input.vue.js';
export { default as InputComponent } from './input.vue.js';

var Input = registerComponent(InputComponent);

export { Input };
